import { memo, useEffect, useRef, useState } from "react"
import { HStack, Input, Center, AspectRatio, Image, Float, Tag, Button } from "@chakra-ui/react"
import { InputGroup } from "@/components/ui/input-group"
import { LuSearch, LuShoppingCart, LuMessageCircle } from "react-icons/lu"
import Slider from "react-slick";
import _ from "lodash";
import { useNavigate } from "react-router"
const ImageCarousel = ({ data }) => {
    let sliderRef = useRef(null);
    const [images, setImages] = useState([])
    const navigate = useNavigate();
    useEffect(() => {
        var data2 = data.setting.images;
        if (data2.length == 1) {
            data2 = [...data2, data2[0]]
        }
        setImages(data2);

    }, [data])

    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        height: 50,
        autoplay: true,
        // lazyLoad: true

        // centerMode:true
    };
    return (
        <div style={{ marginBottom: 0, width: "99%" }} >
            <Slider  {...settings} ref={slider => {
                sliderRef = slider;
            }}>
                {images.map(img => {
                    return (
                        <AspectRatio bg="bg.muted" ratio={4 / 3}  >
                            <div>


                                <Center >
                                    <Image src={img?.lg_url} ></Image>
                                </Center>


                                <div></div>
                            </div>
                        </AspectRatio>
                    )
                })}





            </Slider>


        </div>
    )
}

export default memo(ImageCarousel)